import { View, Text, styled, useTheme } from 'tamagui'
import { SmilePlus, MessageSquareReply, MoreHorizontal, Pencil, Trash2, Pin } from '@tamagui/lucide-icons'
import { useAppStore } from '@/store'

const ActionsBar = styled(View, {
  flexDirection: 'row',
  backgroundColor: '$surfaceRaised',
  borderRadius: '$borderRadiusMd',
  borderWidth: 1,
  borderColor: '$borderDefault',
  overflow: 'hidden',
})

const ActionButton = styled(View, {
  width: 32,
  height: 28,
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  hoverStyle: {
    backgroundColor: '$sidebarHover',
  },
  // @ts-expect-error -- web transition
  style: { transition: 'background-color 100ms ease' },
})

interface MessageActionsProps {
  messageId: string
  hasThread: boolean
}

export function MessageActions({ messageId, hasThread }: MessageActionsProps) {
  const theme = useTheme()
  const {
    openThread,
    setEditingMessageId,
    setDeleteMessageId,
    setReplyingToMessageId,
  } = useAppStore()

  return (
    <ActionsBar
      // @ts-expect-error -- web box-shadow
      style={{ boxShadow: theme.shadowCard?.val || 'none' }}
    >
      <ActionButton onPress={() => setReplyingToMessageId(messageId)}>
        <MessageSquareReply size={16} color="$sidebarMuted" />
      </ActionButton>
      <ActionButton>
        <SmilePlus size={16} color="$sidebarMuted" />
      </ActionButton>
      <ActionButton onPress={() => openThread(messageId)}>
        <MessageSquareReply size={16} color="$sidebarMuted" />
      </ActionButton>
      <ActionButton onPress={() => setEditingMessageId(messageId)}>
        <Pencil size={16} color="$sidebarMuted" />
      </ActionButton>
      <ActionButton>
        <Pin size={16} color="$sidebarMuted" />
      </ActionButton>
      <ActionButton onPress={() => setDeleteMessageId(messageId)}>
        <Trash2 size={16} color="$sidebarMuted" />
      </ActionButton>
      <ActionButton>
        <MoreHorizontal size={16} color="$sidebarMuted" />
      </ActionButton>
    </ActionsBar>
  )
}
